<template>
    <div>
        <div style="display: flex;justify-content: space-between;margin-bottom: 10px;">
            <div style="display: flex;align-items: center;">
                <el-radio-group v-model="signStatus" size="mini" @input="inputChange">
                    <el-radio-button label="1">已签到</el-radio-button>
                    <el-radio-button label="0">未签到</el-radio-button>
                </el-radio-group>
                <div style="margin-left: 20px;color:#318fe6;">签到情况：应签到{{ statistics.total }}人, 已签到{{ statistics.sign }}人, 迟到{{ statistics.late }}人, 未签到{{ statistics.unSign }}人。</div>
            </div>
            <div style="display: flex;align-items: center;">
                 <el-input v-model="searchObj.title" size="mini" style="margin-right: 10px;" placeholder="请输入内容" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
                </el-input>
                <el-button size="mini" @click="openQrCode">二维码</el-button>
                <el-button size="mini" type="primary" @click="hzExport">导出</el-button>
            </div>
        </div>
        <div>
            <el-table ref="table" :data="tableData" border class="jxzb-tables">
                <el-table-column type="index" :label="$tx('fields.index', '序号')" width="50" align="center"></el-table-column>
                <el-table-column prop="personName" label="人员类型" width="110" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div>{{ scope.row.personType==1?'内部人员':'外部人员' }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="userName" label="姓名" width="130" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="userPost" label="职务" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="userDept" label="部门" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="phone" label="电话" width="130" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="remark" label="备注" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column v-if="signStatus==='1'" prop="phone" label="状态" width="110" align="center">
                    <template slot-scope="scope">
                        <div>
                            <div v-if="scope.row.signTime">
                                <div v-if="new Date(scope.row.signTime).getTime()<=new Date(row.startTime).getTime()">正常</div>
                                <div v-else style="color:#c876e7;">迟到</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="signStatus==='1'" prop="signTime" label="签到时间" width="150" align="center" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </div>
         <el-dialog v-if="dialogQrCodeVisible" v-el-drag-dialog title="签到二维码" :append-to-body="true" :visible.sync="dialogQrCodeVisible" width="800px">
            <div class="contQR">
                <h3 style="text-align: center">{{ row.flSubject }}</h3>
                <span v-text-lbl="'scanSignin'" style="text-align: center; display: block; margin-top: 10px">扫描二维码签到</span>
                <img :src="imageUrl" alt="" />
                <p v-text-lbl="'meetingAddress'" style="text-align: left" :place="row.meetPlace">会议地点：{{ row.meetPlace }}</p>
                <p v-text-lbl="'meetingPerson'" style="text-align: left" :person="row.flCreator">召集人：{{ row.flCreator }}</p>
                <p v-text-lbl="'meetingPhone2'" style="text-align: left" :phone="row.flCreatorPhone">联系电话:{{ row.flCreatorPhone }}</p>
                <p v-text-lbl="'meetingTime3'" style="text-align: left;width: 400px;" :time="(row.startTime | timeFormat) + '-' + (row.endTime | timeFormat)">会议时间：{{ row.startTime | timeFormat }} - {{ row.endTime | timeFormat }}</p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            return moment(val).format('YYYY-MM-DD HH:mm')
        }
    },
    components: {},
    props: {
        row: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            dialogVisible: false,
            dialogQrCodeVisible: false,
            showForm: false,
            tableData: [],
            signStatus: '1',
            busiformBtns: [],
            moduleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/hygl/meetPeople/form.html',
                winWidth: 1200,
                delUrl: '/hygl/meetPeople/delete',
                addNewUrl: '/hygl/meetPeople/addNew',
                insertUrl: '/hygl/meetPeople/insert',
                moduleCode: 'meetPeople',
                winHeight: 600,
                updateUrl: '/hygl/meetPeople/update',
                listDataUrl: '/hygl/meetPeople/listdata',
                getByIdUrl: '/hygl/meetPeople/getById'
            },
            imageUrl: '',
            searchObj: {
                title: ''
            },
            statistics: {
                total: 0, // 应到
                sign: 0, // 已签到
                unSign: 0, // 未签到
                late: 0 // 迟到
            }
        }
    },
    computed: {},
    watch: {},
    created() {
        // this.$bus.on('meetInfoFifth', this.meetInfoFifth)
        this.meetInfoFifth()
    },
    beforeDestroy() {
        // this.$bus.off('meetInfoFifth', this.meetInfoFifth)
    },
    mounted() {},
    methods: {
        meetInfoFifth() {
            this.getTableData()
        },
        async getTableData() {
            const _this = this
            const data = {
                pageSize: 9999,
                pageNum: 1,
                urlsearch: `meetId:${this.row.id};`,
                searchMap: {},
                searchAndOr: 'or'
            }
            if (Number(this.signStatus) === 1) {
                data.urlsearch += 'signStatus:1;'
            } else {
                data.urlsearch += 'signStatus!:1;'
            }
            if (this.searchObj.title) {
                data.searchMap.userName = this.searchObj.title
                data.searchMap.userPost = this.searchObj.title
                data.searchMap.userDept = this.searchObj.title
                data.searchMap.remark = this.searchObj.title
            }
            const res = await this.$app.listdata('hygl/meetPeople/listdata', data)
            if (res.code === 'success') {
                this.tableData = res.body.pageInfo.list
            }
            const res1 = await this.$app.listdata('hygl/meetPeople/listdata', {
                pageSize: 9999,
                pageNum: 1,
                urlsearch: `meetId:${this.row.id}`
            })
            if (res1.code === 'success') {
                this.statistics.total = res1.body.pageInfo.total
                const list = res1.body.pageInfo.list
                this.statistics.sign = list.filter(item => item.signStatus === 1).length
                this.statistics.unSign = list.filter(item => !item.signStatus).length
                this.statistics.late = list.filter(item => {
                    return item.signTime && new Date(item.signTime).getTime() > new Date(_this.row.startTime).getTime()
                }).length
            }
        },
        searchClick() {
            this.getTableData()
        },
        // 获取二维码
        async openQrCode(row) {
            const _this = this
            this.dialogQrCodeVisible = true
            await this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                url: '/base/paramConfig/findParamValueByName',
                params: {
                    orgCode: _this.loginUser.orgCode,
                    paramName: 'mpp.h5app.baseurl'
                }
            }).then((res) => {
                if (res.code === 'success') {
                    var urlStr = res.body.value + '#/QRwaiting?apigateway=' + location.host + '&meetId=' + _this.row.id + ''
                    urlStr = encodeURI(urlStr)
                    this.$http({
                        method: 'GET',
                        contentType: 'application/x-www-form-urlencoded',
                        url: '/hygl/hyap/getQrCode',
                        params: {
                            url: urlStr
                        }
                    }).then((res) => {
                        if (res.code === 'success') {
                            _this.imageUrl = 'data:image/png;base64,' + res.body.image
                        } else {
                            _this.$message.error(res.message)
                        }
                    })
                } else {
                    this.$message.error(this.$tx('hygl.message.noFindH5', '未检测到h5参数！请联系管理员'))
                }
            })
        },
        inputChange(val) {
            this.getTableData()
        },
        hzExport() {
            const headerAlias = {
                'personType': '人员类型',
                'userName': '姓名',
                'userPost': '职务',
                'userDept': '部门',
                'phone': '电话',
                'remark': '备注'

            }

            console.log('JSON.stringify(headerAlias)', JSON.stringify(headerAlias))
            if (Number(this.signStatus) === 1) {
                window.open(`/apigw/hygl/meetPeople/dynamicExportData?pageNum=1&pageSize=9999&urlsearch=meetId:${this.row.id};signStatus:1&headerAlias=${encodeURIComponent(JSON.stringify(headerAlias))}&fileName=${encodeURIComponent('签到信息.xlsx')}`)
            } else {
                window.open(`/apigw/hygl/meetPeople/dynamicExportData?pageNum=1&pageSize=9999&urlsearch=meetId:${this.row.id};signStatus!:1&headerAlias=${encodeURIComponent(JSON.stringify(headerAlias))}&fileName=${encodeURIComponent('签到信息.xlsx')}`)
            }
        },
        // 关闭
        toClose() {
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.dialog_top {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .el-button {
        margin-left: 10px;
        padding: 8px 15px;
    }
}
.contQR {
    width: 372px;
    height: 500px;
    margin: 0 auto;
    h3,
    h4 {
        margin: 0;
    }
    img {
        width: 340px;
        height: 340px;
        margin: 0 auto;
    }
    p {
        margin: 0;
        padding: 0 40px;
        line-height: 22px;
    }
}
</style>
